<template>
  <module-template id="scrolltainer" :title="formTitle">
    <v-card>
      <v-card-text>
        <v-form
          @submit.prevent="createBPDefinition"
          class="mx-auto"
          v-model="valid"
        >
          <bp-definition-form-fields
            :init-values="data"
            :valid="valid"
            @input="onInput($event)"
            @jsonError="
              showInvalidForm = true;
              formError = $event;
            "
          ></bp-definition-form-fields>
          <form-buttons
            :canSubmit="valid"
            :confirmText="$t('global.action.save')"
            @cancel="onCancel"
          ></form-buttons>
        </v-form>
      </v-card-text>
    </v-card>

    <v-dialog v-model="showInvalidForm" persistent :width="500">
      <v-card>
        <v-card-title>
          <span class="headline">
            {{ $t("global.business-process.invalid-form") }}
          </span>
        </v-card-title>

        <v-card-text>
          <v-alert
            style="background-color: #fff4e7; border: 1px solid #efebe7"
            icon="pic-warning"
          >
            {{ formError }}
          </v-alert>
          <strong>{{ $t("global.business-process.fix-form") }}</strong>
        </v-card-text>

        <v-card-actions class="justify-end">
          <v-btn
            depressed
            class="button"
            @click="
              showInvalidForm = false;
              formError = '';
            "
          >
            {{ $t("global.action.close") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </module-template>
</template>

<script>
import FormButtons from "@/components/FormButtons";
import ModuleTemplate from "@/components/layout/ModuleTemplate";
import { post, get } from "@/model/api";
import { createInvalidGraphError } from "@/model/util";
import BpDefinitionFormFields from "@/components/businessProcess/bpDefinition/BpDefinitionFormFields";

export default {
  name: "CreateBPDefinition",
  components: {
    ModuleTemplate,
    BpDefinitionFormFields,
    FormButtons,
  },
  data() {
    return {
      defaultForm: undefined,
      data: {
        name: "",
        description: "",
        form: "",
        jsonGraph: "",
      },
      valid: false,

      showInvalidForm: false,
      formError: "",
    };
  },

  computed: {
    formTitle() {
      return this.$t("global.header.create", [
        this.$t("global.business-process.bp-definition").toLowerCase(),
      ]);
    },
  },

  methods: {
    onCancel() {
      this.$router.push({ name: "BP definitions" });
    },

    onInput(data) {
      this.data = data;
    },
    onError(error) {
      this.$store.commit("showError", error);
    },
    async getDefaultBpForm() {
      return await get("/environment-property/default-bp-form").catch(
        (error) => {
          this.onError(error);
        }
      );
    },

    handleCreateError(e) {
      if (!e.message) {
        return e;
      }
      if (e.message === "unique.constraint" && e.arguments) {
        if (e.arguments[0] === "name") {
          return this.$t("global.msg.already-exists", [
            this.$t("global.business-process.bp-definition"),
            this.$t("global.concepts.name"),
            e.arguments[1],
          ]);
        }
      }
      return createInvalidGraphError(e);
    },

    async createBPDefinition() {
      if (this.data.form) {
        try {
          JSON.parse(this.data.form);
        } catch (e) {
          this.showInvalidForm = true;
          this.formError = e.message;
          return;
        }
      }
      const data = {
        name: this.data.name,
        jsonGraph: this.data.jsonGraph,
        form: this.data.form,
        description: this.data.description,
      };
      await post("/business-process/save", data)
        .then(() => {
          this.$router.push({ name: "BP definitions" });
        })
        .catch((e) => {
          this.$store.commit("showError", this.handleCreateError(e));
        });
    },
  },
  async created() {
    this.data.form = JSON.stringify(await this.getDefaultBpForm(), null, 2);
  },
};
</script>
